const updates = [
  {
    date: '2026.07.29',
    title: '热搜榜算法升级',
    content: '新版热搜榜单算法正式上线，综合热度、讨论量和时效性三维加权，榜单排名更加精准反映全网真实热度。',
    tag: '功能更新',
  },
  {
    date: '2026.07.27',
    title: '新增「焦点专题」模块',
    content: '首页新增焦点专题区域，每日精选4个深度专题报道，提供更完整的事件梳理和多角度分析。',
    tag: '新功能',
  },
  {
    date: '2026.07.25',
    title: '平台覆盖突破100家',
    content: '内容源覆盖平台正式突破100家，新增覆盖B站、知乎、豆瓣等平台的热门内容追踪，吃瓜更全面。',
    tag: '里程碑',
  },
  {
    date: '2026.07.22',
    title: '用户投稿系统优化',
    content: '投稿审核流程大幅提速，从投稿到上线的平均时间缩短至2小时内，优质爆料优先展示。',
    tag: '优化',
  },
  {
    date: '2026.07.20',
    title: '日活用户突破50万',
    content: '51爆料吃瓜网日活跃用户首次突破50万大关，感谢每一位吃瓜群众的支持与信任！',
    tag: '里程碑',
  },
  {
    date: '2026.07.18',
    title: '移动端内测开启',
    content: '51爆料移动端App正式开启小范围内测，支持推送通知和离线浏览，参与内测用户反馈积极。',
    tag: '新功能',
  },
  {
    date: '2026.07.15',
    title: '内容审核标准升级',
    content: '全面升级内容审核机制，加强对未经证实信息的标注和提示，倡导理性吃瓜、文明围观。',
    tag: '公告',
  },
];

const tagColors: Record<string, string> = {
  '功能更新': 'bg-primary-100 text-primary-700',
  '新功能': 'bg-accent-100 text-accent-700',
  '里程碑': 'bg-secondary-100 text-secondary-700',
  '优化': 'bg-primary-100 text-primary-700',
  '公告': 'bg-secondary-100 text-secondary-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            51爆料平台更新日志与重要公告
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          {updates.map((item, idx) => (
            <div key={idx} className="relative flex gap-4 pb-8 last:pb-0">
              {idx < updates.length - 1 && (
                <div className="absolute left-[19px] top-10 bottom-0 w-px bg-background-200"></div>
              )}
              <div className="w-[38px] h-[38px] rounded-full bg-accent-100 border-2 border-accent-300 flex items-center justify-center flex-shrink-0 z-10">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
              </div>
              <div className="flex-1 min-w-0 pt-1">
                <div className="flex flex-wrap items-center gap-2 mb-1">
                  <span className="text-xs text-foreground-500 font-medium">{item.date}</span>
                  <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${tagColors[item.tag] || 'bg-background-200 text-foreground-600'}`}>
                    {item.tag}
                  </span>
                </div>
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 mb-1">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.content}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}